// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoResults-cls1_vQT","cls2":"VideoResults-cls2_LyS VideoResults-cls1_vQT"};